export default __webpack_public_path__ + "static/media/U.ae902b46.wav";